import { render, staticRenderFns } from "./NavBrand.vue?vue&type=template&id=4476afd7&"
import script from "./NavBrand.vue?vue&type=script&lang=js&"
export * from "./NavBrand.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports